import { render, staticRenderFns } from "./event.vue?vue&type=template&id=2472d0b4&scoped=true&"
import script from "./event.vue?vue&type=script&lang=js&"
export * from "./event.vue?vue&type=script&lang=js&"
import style0 from "./event.vue?vue&type=style&index=0&id=2472d0b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472d0b4",
  null
  
)

export default component.exports